{
  "userSettings": "Osobní nastavení uživatele",
  "breadcrumb": {
    "users": "Uživatelé"
  },
  "notification": {
    "all": "Vše",
    "unread": "Nepřečtené",
    "forwarded": "Přeposláno v rámci zástupu uživatele <UserHighlight>{{user}}</UserHighlight>"
  },
  "common": {
    "resetColumnWidth": "Obnovit výchozí šířku",
    "resetColumnWidths": "Obnovit výchozí šířky",
    "copiedToTranslations": "Zkopírováno do překladů",
    "copyFromDefault": "Převzít z výchozího pole",
    "copied": "Zkopírováno",
    "clickToCopy": "Klikněte pro zkopírování",
    "actions": {
      "saveAndProceed": "Uložit a pokračovat",
      "proceedWithoutChanges": "Pokračovat bez uložení",
      "continueEditing": "Pokračovat v editaci",
      "stayOnPage": "Zůstat na stránce",
      "stayOnForm": "Zpět k formuláři"
    },
    "dateOfActivation": "Datum aktivace",
    "dateOfDeactivation": "Datum deaktivace",
    "buttonName": "Název tlačítka",
    "dateMask": "DD.MM.YYYY",
    "error": "Chyba",
    "errorPage": {
      "somethingWentWrong": "Oops!",
      "tryAgainLater": "Něco se nepodařilo. Zkuste stránku obnovit, nebo se vraťte na hlavní stránku.",
      "reloadPage": "Obnovit stránku",
      "goHome": "Přejít na hlavní stránku",
      "copyFullStackTrace": "Kopírovat kompletní stack trace",
      "copied": "Zkopírováno!"
    },
    "loading": "Načítám...",
    "share": "Sdílet",
    "invalidGuid": "Neplatný GUID",
    "activate": "Aktivovat",
    "add": "Přidat",
    "addAll": "Přidat vše",
    "addColumn": "Přidat sloupec",
    "addModule": "Přidat modul",
    "agenda": "Agenda",
    "childModule": "Podřízený modul",
    "addRole": "Přidat roli",
    "bulkAddRoles": "Přidat role hromadně",
    "bulkAddRolesModalTitle": "Hromadné přidání role",
    "bulkAddRolesPreview": "Přiřazeno {{assigned}} rolí.",
    "sortById": "Seřadit podle ID",
    "bulkAddUsers": "Přidat uživatelům hromadně",
    "noUsersFound": "Žádní uživatelé nenalezeni",
    "addRow": "Přidat řádek",
    "transferRoles": "Přenést role",
    "addUser": "Přidat uživatele",
    "addTab": "Přidat záložku",
    "addSubTab": "Přidat záložku jako podsekci",
    "selectParentSection": "Vyberte nadřazenou sekci",
    "noSectionsOnTab": "Na této záložce nejsou žádné sekce. Vytvořte nejprve sekci.",
    "selectTab": "Vyberte záložku",
    "selectSubTab": "Vyberte podsekci",
    "subTab": "Podsekce",
    "subTabDefault": "Hlavní",
    "subTabNew": "Nová podsekce",
    "tab": "Záložka",
    "tabName": "Název záložky",
    "subTabName": "Název podsekce",
    "advanceFilter": "Pokročilé filtrování",
    "again": "Znovu",
    "agendaName": "Název agendy",
    "agendaRoles": "Role agend",
    "aggregationGroups": "Agregační skupiny",
    "and": "a",
    "archivate": "Archivovat",
    "atLeastOneRequired": "Musí být zaškrtnuto alespoň jedno zaškrtávací pole",
    "attributeName": "Název atributu",
    "author": "Autor",
    "back": "Zpět",
    "button": "Tlačítko",
    "byUser": "uživatelem",
    "cancel": "Zrušit",
    "checkbox": "Zaškrtávací políčko",
    "close": "Zavřít",
    "color": "Barva",
    "columns": "Sloupce",
    "aggregation": "Agregace",
    "grouping": "Seskupení",
    "pinLeft": "Připnout vlevo",
    "pinRight": "Připnout vpravo",
    "comingSoon": "Připravujeme",
    "conditions": "Podmínky",
    "massChanges": "Hromadné změny",
    "logs": "Logy",
    "confirm": "Potvrdit",
    "create": "Vytvořit",
    "copy": "Kopírovat",
    "copyRow": "Kopírovat řádek",
    "dataModel": "Datový model",
    "printConfigurations": "Tiskové konfigurace",
    "update": "Aktualizovat",
    "invalidPhoneNumber": "Neplatné telefonní číslo",
    "isRequired": "je povinné pole",
    "mustBeNumber": "musí být číslo",
    "isKey": "Klíč",
    "clear": "Vyprázdnit",
    "none": "Žádné",
    "noneMale": "Žádní",
    "sum": "Součet",
    "average": "Průměr",
    "minimum": "Minimum",
    "maximum": "Maximum",
    "count": "Počet",
    "no": "Ne",
    "notFilled": "Nevyplněno",
    "notSelected": "Nevybráno",
    "yes": "Ano",
    "selectAnItem": "Vyberte položku",
    "openInNewTab": "Otevřít v nové záložce",
    "versions": {
      "button": "Verze",
      "at": "dne",
      "latestStoredVersion": "Poslední uložená verze",
      "createdBy": "Vytvořil",
      "lastUpdateBy": "Aktualizováno",
      "restore": "Použít jako aktuální verzi",
      "preview": "Náhled",
      "substitutedBy": "v režimu zástupu. Zastupující uživatel:",
      "substitutedByShort": "zastoupen:",
      "modal": {
        "title": "Verze",
        "latestStoredVersion": "ID poslední uložené verze:"
      }
    },
    "user": {
      "withoutName": "Bez jména"
    },
    "date": {
      "_": "Datum",
      "day": "Den",
      "month": "Měsíc",
      "time": "Čas",
      "today": "Dnes",
      "year": "Rok"
    },
    "dateTimeCalendar": "Vyberte datum a čas",
    "deactivate": "Deaktivovat",
    "deactive": {
      "message": "Potvrzením dojde u uživatele k deaktivaci. přístupových údajů"
    },
    "delete": "Smazat",
    "deleted": {
      "roles": "Role byly úspěšně smazané"
    },
    "download": "Stáhnout",
    "downloadAll": "Stáhnout vše",
    "downloadSuccess": "Soubor byl úspěšně stažen",
    "failedToDownload": "Stahování se nezdařilo",
    "draft": "Návrh",
    "edit": "Upravit",
    "editable": "Upravitelný",
    "editRow": "Upravit řádek",
    "editValidFrom": "Editovat platnost od",
    "editValidUntil": "Editovat platnost do",
    "email": "Email",
    "empty": "Prázdné",
    "contactEmail": "Kontaktní email",
    "reference": "Reference",
    "export": "Export",
    "filterBy": "Filtrovat",
    "filters": "Filtry",
    "from": "Od",
    "to": "Do",
    "files": "Soubory",
    "file": "Soubor",
    "flow": {
      "_": "Flow",
      "approval": "Flow Schvalování",
      "runFunction": "Flow Spouštění funkcí",
      "archive": "Flow Archivace",
      "comment": "Flow Komentování",
      "create": "Flow Tvorba záznamu",
      "delete": "Flow Mazání",
      "edit": "Flow Editace záznamu",
      "history": "Flow Historie",
      "read": "Flow Čtení",
      "title": "Flow"
    },
    "flowApproval": "flow.approval",
    "flowArchive": "flow.archive",
    "flowComment": "flow.comment",
    "flowCreate": "flow.create",
    "flowDelete": "flow.delete",
    "flowHistory": "flow.history",
    "flowRead": "flow.read",
    "form": "Formulář",
    "personalSettings": "Osobní nastavení",
    "previous": "Předchozí",
    "next": "Další",
    "grid": "Grid",
    "helios": {
      "_": "Helios",
      "copy": "Helios Kopírování",
      "copyLine": "Helios Kopírování v řádku",
      "create": "Helios Tvoření",
      "createLine": "Helios Tvoření v řádku",
      "delete": "Helios Smazání",
      "edit": "Helios Editace",
      "editLine": "Helios Editace v řádku",
      "export": "Helios Export tabulky",
      "title": "Helios",
      "saved": "Úspěšně uloženo"
    },
    "Helios": {
      "edit": "Helios editace"
    },
    "heliosCopy": "Helios.copy",
    "heliosCopyLine": "Helios.copyLine",
    "heliosCreate": "Helios.create",
    "heliosCreateLine": "Helios.createLine",
    "heliosDelete": "Helios.delete",
    "heliosEditLine": "Helios.editLine",
    "heliosExport": "Helios.export",
    "hidden": "Skrytý",
    "icon": "Ikona",
    "removeIcon": "Odstranit ikonu",
    "individualChoice": "Jednotlivá volba",
    "infinitive": "Neomezeně",
    "invalidEmail": "Neplatný email",
    "invalidInput": "Neplatný vstup",
    "isUnique": "Unikátní",
    "lastModified": "Poslední úprava:",
    "maxLength": "Max. počet povolených písmen",
    "maxSize": "Soubor je větší než",
    "maxValue": "Hodnota musí být menší nebo rovna: ",
    "minValue": "Hodnota musí být větší nebo rovna: ",
    "rangeValue": "Hodnota musí být v rozsahu {{min}} až {{max}}",
    "multiSelectOption": "Možnost multi-select",
    "notSave": "Neuložit",
    "noEdits": "Žádné změny k uložení",
    "name": "Jméno",
    "name_cs": "Název (CZ)",
    "name_en": "Název (EN)",
    "name_sk": "Název (SK)",
    "label_cs": "Název (CZ)",
    "label_en": "Název (EN)",
    "label_sk": "Název (SK)",
    "noCorrectPattern": "Neplatný formát",
    "noData": "Žádná data",
    "noFiles": "Žádné soubory",
    "noIcon": "Žádna ikona nenalezena",
    "noRequiredField": "Toto pole nemusí být vyplněno",
    "noSelected": "Nevybráno",
    "notifications": "Notifikace",
    "number": "Číslo",
    "operation": "Operace",
    "options": "Možnosti",
    "or": "nebo",
    "organization": "Organizace",
    "outOf": "z",
    "phoneNumber": "Telefon",
    "placeholder": {
      "columnName": "Název sloupce",
      "email": "Email uživatele",
      "contactEmail": "Kontaktní email uživatele",
      "reference": "Reference",
      "icon": "Vyberte ikonu",
      "multilangName": "Název",
      "name": "Jméno uživatele",
      "name_cs": "Název (CZ)",
      "name_en": "Název (EN)",
      "name_sk": "Název (SK)",
      "role": "Jméno nové role",
      "rowCount": "Počet řádků"
    },
    "preview": "Náhled",
    "publish": "Zveřejnit",
    "required": "Povinné pole",
    "selectedItems": "Vybrané položky",
    "removeItem": "Odstranit {{item}}",
    "richText": {
      "sizeSmall": "Malé",
      "sizeNormal": "Normální",
      "sizeLarge": "Velké",
      "sizeHuge": "Obrovské",
      "fontSansSerif": "Bezpatkové",
      "fontSerif": "Patkové",
      "fontMonospace": "Monospace",
      "tooltipVisitUrl": "Navštívit URL:",
      "tooltipEdit": "Upravit",
      "tooltipSave": "Uložit",
      "tooltipRemove": "Odstranit",
      "tooltipEnterLink": "Zadejte odkaz:",
      "promptEnterUrl": "Zadejte platnou URL: (https://www.example.com)"
    },
    "requiredWithFieldName": "Pole \"{{fieldName}}\" je povinné",
    "requiredWithFieldNameAndCount": "Pole \"{{fieldName}}\" je povinné ({{count}}x)",
    "invalidText": "Neplatný text",
    "diactricCharactersNotAllowed": "Diakritické znaky nejsou povoleny",
    "role": {
      "added": "Role byla úspěšně přidána"
    },
    "roles": {
      "_": "Role",
      "": "Editace",
      "approval": "Schvalování",
      "archive": "Archivace",
      "comment": "Komentování",
      "copy": "Kopírování",
      "copyLine": "Kopírovat v řádku",
      "create": "Tvoření",
      "createLine": "Tvoření v řádku",
      "delete": "Mazání",
      "edit": "Editace",
      "editLine": "Editace řádku",
      "export": "Export",
      "history": "Historie",
      "read": "Čtení"
    },
    "rowControls": "Ovládání řádku",
    "rowCount": "Počet řádků",
    "refresh": "Obnovit",
    "refreshCooldown": "Obnovit ({{seconds}}s)",
    "save": "Uložit",
    "saveDraft": "Uložit návrh",
    "saveAndClose": "Uložit a Zavřít",
    "search": {
      "_": "Hledat",
      "icons": "Hledat v ikonách",
      "modules": "Hledat v modulech",
      "modulesAndAgendas": "Hledat v modulech a agendách",
      "notificationTemplates": "Hledat v notifikačních šablonách",
      "records": "Hledat v záznamech",
      "roles": "Hledat v rolích",
      "tables": "Hledat v tabulkách",
      "users": "Hledat v uživatelích",
      "dataSources": "Hledat zdroje",
      "substitutions": "Hledat v zástupech"
    },
    "selectedUsers": "Vybraní uživatelé",
    "selectedRoles": "Vybrané role",
    "noRolesFound": "Žádné role nenalezeny",
    "section": "Sekce",
    "parentSectionName": "Název nadřazené sekce",
    "sectionName": "Název sekce",
    "collapsed": "Zobrazit sekci jako sbalenou",
    "description": "Popis",
    "select": "Vyberte",
    "selected": "Vybráno",
    "selectValue": "Vyberte hodnotu",
    "settings": "Nastavení",
    "settingsAdmin": "Administrátor nastavení",
    "showAll": "zobrazit vše",
    "loadMore": "Zobrazit více",
    "showingRecords": "Zobrazeno {{shown}} z {{total}} záznamů",
    "state": "Stav",
    "stateLabels": {
      "draft": "Návrh",
      "active": "Aktivní",
      "disable": "Vypnuto"
    },
    "source": "Zdroj",
    "storedValue": "V databázi",
    "storedValueHint": "Ponechte prázdné pro uložení názvu",
    "storedValuesMustBeUnique": "Hodnoty v databázi musí být jedinečné",
    "sourceType": {
      "createdDate": "Vytvořeno",
      "dateNow": "Dnešní den",
      "emptyValue": "Prázdná hodnota",
      "formItem": "Položka formuláře",
      "realUserId": "Skutečné Id uživatele",
      "updatedDate": "Aktualizováno",
      "userEmail": "Email uživatele",
      "userId": "Id uživatele",
      "userRole": "Role uživatele",
      "userContactEmail": "Kontaktní email uživatele",
      "userReference": "Reference uživatele"
    },
    "specialChar": "Reference",
    "success": "Úspěšně odesláno",
    "tableControls": "Ovládání tabulky",
    "tellNumber": "Telefonní číslo",
    "emailWithUserId": "E-mail s User ID",
    "templatesAdmin": "Administrátor šablon",
    "text": "Text",
    "textField": "Textové pole",
    "title": "Nadpis",
    "type": "Typ",
    "unique": "Unikátní",
    "isActionInput": "Editovatelné v detailu",
    "isParentInput": "Rodičovský vstup",
    "updateDateOfActivation": "Aktualizovat datum aktivace",
    "updateDateOfDeactivation": "Aktualizovat datum deaktivace",
    "upload": "Nahrát",
    "uploadFileSuccess": "Soubor byl úspěšně nahrán",
    "uploadFileError": "Chyba při nahrávání souboru",
    "uploadFromGoogle": "Připojit z Google Disku",
    "usable": "Použitelný",
    "userDefinedField": "Uživatelsky definované pole",
    "userDetails": "Detaily uživatele",
    "userInfo": "Info uživatele",
    "usernamePlaceholder": "Uživatel",
    "usersAdmin": "Administrátor uživatelů",
    "userSettings": "Uživatelská nastavení",
    "validFrom": "Platnost od",
    "validUntil": "Platnost do",
    "value": "Hodnota",
    "view": "Zobrazit",
    "viewRoles": "Role pohledů",
    "visible": "Viditelný",
    "visibleinmenu": "Viditelný",
    "warning": "Pozor",
    "widget": "Widget",
    "write": "Napište",
    "helper": {
      "conditions": "Podmínky"
    },
    "maxLengthLimited": "Max. počet povolených písmen (ne víc než 1000)",
    "maxLengthError": "Pole může obsahovat maximálně {{count}} znaků.",
    "visibilityName": "Název viditelnosti",
    "startValue": "Počáteční hodnota",
    "defaultValue": "Defaultní hodnota",
    "defaultValueSource": "Defaultní vybraná hodnota",
    "offsetDays": "Posun dní",
    "offsetDaysHelp": "Počet dní přičtených k aktuálnímu datu (záporné = minulost)",
    "favorite": "Přidat do oblíbených",
    "unfavorite": "Odebrat z oblíbených"
  },
  "form": {
    "section": {
      "error": {
        "duplicate": "Název buňky musí být jedinečný",
        "remove_col": "Nelze odstranit sloupec, protože obsahuje položky",
        "remove_row": "Nelze odstranit řádek, protože obsahuje položky"
      },
      "grid": {
        "delete_row": "Odstraňování řádku {{index}}",
        "delete_col": "Odstraňování sloupce {{index}}",
        "rows": "Řádky",
        "columns": "Sloupce",
        "validation": {
          "valid": "Pozice je platná",
          "out_of_bounds": "Mimo mřížku",
          "collision_multiple": "Kolize s více položkami",
          "collision_single": "Překrývá položku",
          "size_mismatch": "Rozdílná velikost položek"
        }
      }
    }
  },
  "languages": {
    "cs": "Čeština",
    "en": "Angličtina",
    "sk": "Slovenština",
    "translateToLanguage": {
      "cs": "Česky",
      "en": "Anglicky",
      "sk": "Slovensky"
    }
  },
  "login": {
    "email": "E-mail",
    "emailPlaceholder": "Zadejte e-mail",
    "continue": "Pokračovat",
    "redirecting": "Přesměrování k přihlášení...",
    "error": {
      "unknow": "Došlo k chybě. Prosím, zkuste to znovu později.",
      "unknown": "Došlo k chybě. Prosím, zkuste to znovu později.",
      "accessDenied": "Přihlášení bylo zrušeno. Zkuste to znovu.",
      "exchange": "Přihlášení se nepodařilo dokončit. Zkuste to znovu.",
      "stateMismatch": "Relace přihlášení je neplatná. Zkuste to znovu.",
      "nonceMismatch": "Relace přihlášení je neplatná. Zkuste to znovu.",
      "keycloak": "Přihlášení se nezdařilo. Zkuste to znovu.",
      "keycloakExpired": "Platnost přihlášení vypršela. Zkuste to znovu.",
      "keycloakForbidden": "Toto přihlášení zde nelze použít.",
      "keycloakNotFound": "Nebyl nalezen odpovídající účet.",
      "keycloakConflict": "Tento účet je propojen s jiným přihlášením. Správce ho může obnovit."
    },
    "login": {
      "google": "Přihlásit se pomocí Google",
      "microsoft": "Přihlásit se pomocí Microsoft",
      "subtitle": {
        "email": "Zadejte e-mail a pokračujte",
        "google": "Přihlaste se ke svému účtu Google nebo zadejte údaje",
        "microsoft": "Přihlaste se ke svému účtu Microsoft nebo zadejte údaje"
      }
    },
    "pin": {
      "forgotPin": "Zapomněli jste PIN?",
      "login": "Přihlásit se",
      "subtitle": "Pro přihlášní se ke svému účtu zadejte PIN"
    },
    "stayLoggedIn": "Zůstat přihlášen",
    "title": "Přihlášení"
  },
  "supplier": {
    "title": "Sdíleno s vámi",
    "empty": "Zatím s vámi nebylo nic sdíleno",
    "system": {
      "flow": "Flow",
      "erp": "ERP"
    },
    "record": {
      "unavailable": "Tento sdílený záznam není k dispozici",
      "unavailableInShareMode": "Není k dispozici ve sdíleném režimu"
    }
  },
  "accessDenied": {
    "title": "Přístup odepřen",
    "message": "Váš účet nemá přístup k této aplikaci.",
    "backToLogin": "Zpět na přihlášení"
  },
  "modal": {
    "sourceSelect": {
      "title": "Vyberte zdroj"
    }
  },
  "modulesAndAgendas": {
    "moduleSelect": {
      "required": "Musíte vybrat modul"
    }
  },
  "sidebar": {
    "admin": {
      "core": {
        "_": "Core",
        "appSettings": "Nastavení aplikace",
        "assistants": "Asistenti",
        "modules": "Moduly",
        "roles": "Role",
        "substitutability": {
          "_": "Zastupitelnost",
          "detail": "Detail zástupu"
        },
        "users": "Uživatelé"
      },
      "flow": {
        "_": "Flow",
        "agendaImports": {
          "_": "Import agend"
        },
        "modules&agendas": {
          "_": "Moduly a Agendy",
          "create": "Vytvořit agendu",
          "edit": "Upravit agendu",
          "view": " Pohled"
        },
        "notification": "Notifikační šablony",
        "restApiConnections": "Rest api připojení",
        "tables": {
          "_": "Tabulky",
          "view": "Pohled"
        }
      },
      "helios": {
        "_": "Helios",
        "dataSource": "Datové zdroje",
        "functions": "Funkce",
        "tables": "Tabulky",
        "templates": "Šablony",
        "notification": "Notifikační šablony",
        "templatesImport": "Import šablon"
      }
    },
    "adminZone": "Administrátorská zóna",
    "core": {
      "appSettings": "Nastavení aplikace",
      "assistants": "Asistenti",
      "modules": "Moduly",
      "roles": "Role",
      "users": "Uživatelé"
    },
    "flow": {
      "agendas": "Agendy",
      "modulesAndAgendas": {
        "_": "Moduly a Agendy",
        "create": "Vytvořit modul",
        "edit": "Upravit modul",
        "view": " Pohled"
      },
      "notification": "Notifikační šablony",
      "tables": "Tabulky"
    },
    "helios": {
      "dataSource": "Datové zdroje",
      "functions": "Funkce",
      "tables": "Tabulky",
      "templates": "Šablony"
    },
    "logout": "Odhlásit se",
    "feedback": "Odeslat zpětnou vazbu",
    "profile": "Profil",
    "userSettings": "Osobní nastavení",
    "substitutes": "Zástup",
    "substitutesTabs": {
      "planned": "Plánované zástupy",
      "substituteUser": "Zastupovat uživatele",
      "detail": "Detail zástupu",
      "columns": {
        "substitutionType": "Typ zástupu",
        "dateFrom": "Datum od",
        "dateTo": "Datum do",
        "absentUser": "Zastupovaný uživatel",
        "absentUserEmail": "Email zastupovaného",
        "substituteUser": "Zastupující uživatel",
        "substituteUserEmail": "Email zastupujícího",
        "roles": "Role"
      }
    },
    "user": {
      "action": "Nevyřízené úkoly",
      "applicationsAndModules": "Aplikace / Moduly",
      "contacts": "Rozdělovník",
      "info": "Nepřečtené informace",
      "overview": "Přehled",
      "yourModules": "Vaše moduly"
    },
    "userZone": "Uživatelská zóna"
  },
  "filters": {
    "title": "Filtry",
    "savedFilters": "Uložené filtry",
    "selectSavedFilter": "Vyberte uložený filtr",
    "reset": "Resetovat",
    "apply": "Potvrdit",
    "editFilter": {
      "title": "Upravit filtr"
    },
    "created": "Filtr byl úspěšně vytvořen",
    "updated": "Filtr byl úspěšně upraven",
    "deleted": "Filtr byl úspěšně smazán",
    "nestedLevelWarning": "Pro filtrování 2. úrovně vnoření (položek položek) musí být zapnuté zobrazení sloupců ve výsledcích filtrování",
    "saveFilter": {
      "title": "Uložit filtr",
      "name": "Název filtru",
      "placeholder": "Zadejte název filtru",
      "save": "Uložit",
      "default": "Výchozí",
      "global": "Dostupný pro všechny"
    }
  },
  "table": {
    "buttons": {
      "add": "Přidat",
      "exportCsv": "Exportovat do CSV",
      "delete": "Smazat",
      "edit": "Upravit",
      "importFunctions": "Importovat funkci"
    },
    "common": {
      "selectDateRange": "Platnost"
    },
    "footer": {
      "rowsPerPage": "Řádků na stránku"
    },
    "header": {
      "classId": "Číslo třídy",
      "created": "Vytvořeno",
      "createdBy": "Vytvořil",
      "creator": "Vytvořil",
      "dateOfActivation": "Datum aktivace",
      "dateOfChange": "Datum změny",
      "dateOfDeactivation": "Datum deaktivace",
      "dateOfExport": "Datum exportu",
      "dateOfImport": "Datum importu",
      "email": "Email",
      "contactEmail": "Kontaktní email",
      "exists": "Existuje",
      "flow": "Flow",
      "folderId": "Číslo pořadače",
      "fullName": "Jméno",
      "helios": "Helios",
      "icon": "Ikona",
      "id": "ID",
      "lastChangedDate": "Datum poslední změny",
      "moduleName": "Název modulu",
      "module": "Modul",
      "name": "Název",
      "name_Cz": "Název (CZ)",
      "name_En": "Název (EN)",
      "name_Sk": "Název (SK)",
      "numberOfColumns": "Počet sloupců",
      "numberOfRows": "Počet řádků",
      "reference": "Reference",
      "role": "Role",
      "detail": "Detail",
      "roleName": "Název role",
      "roles": "Role",
      "assignedRoles": "Přidělené role",
      "assistants": "Asistenti",
      "permissions": "Oprávnění",
      "rowCount": "Počet řádků",
      "schema": "Schema",
      "status": "Status",
      "tags": "Štítky",
      "userName": "Uživatelské jméno",
      "validFrom": "Platné od",
      "validity": "Platnost",
      "validTo": "Platné do",
      "value": "Hodnota",
      "views": "Pohledy",
      "visibility": "Viditelnost",
      "tableName": "Název tabulky",
      "userSettings": "Uživatelská nastavení",
      "dataSources": "Datové zdroje",
      "agendaName": "Název agendy",
      "updated": "Aktualizováno",
      "authorOfCurrentVersion": "Autor aktuální verze",
      "dataSource": "Datový zdroj",
      "type": "Typ",
      "loginUrl": "URL přihlášení",
      "domainUrl": "URL domény",
      "googleUrl": "URL Google",
      "profile": "Profil",
      "timeZoneId": "Časové pásmo",
      "column": "Sloupec",
      "database": "Databáze",
      "item": "Položka",
      "parentColumn": "Rodičovský sloupec",
      "general": "Obecné",
      "wslUrlBasic": "Základní URL",
      "wsUrlDomain": "Doménová URL",
      "wsUrlGoogle": "Google URL",
      "wsProfile": "Profil",
      "valid": "Validní",
      "maxConcurrentConnections": "Maximální počet souběžných připojení",
      "isCommon": "Obecná",
      "datasourceName": "Datový zdroj",
      "isRecordFunction": "Položková",
      "heliosFunctionId": "Helios ID",
      "number": "ID",
      "alias": "Alias",
      "description": "Popis",
      "label": "Název",
      "vsgAssistantId": "ID asistenta",
      "subject": "Předmět",
      "baseUrl": "Base URL",
      "authType": "Typ autentizace",
      "isConnected": "Připojeno"
    },
    "status": {
      "active": "Aktivní",
      "archived": "Archivován",
      "design": "Design",
      "draft": "Návrh",
      "inactive": "Neaktivní",
      "invited": "Pozván",
      "inprocess": "Rozpracováno",
      "imported": "Importováno",
      "new": "Nový",
      "pending": "Čekající",
      "online": "Online",
      "offline": "Offline",
      "unknown": "Neznámý",
      "success": "Úspěch",
      "failed": "Selhalo",
      "created": "Vytvořeno",
      "updated": "Aktualizováno"
    }
  },
  "toast": {
    "records": {
      "displayValuesOmitted": "Zobrazované hodnoty propojených záznamů nebyly načteny, protože stránka překračuje limit {{limit}} záznamů. Místo hodnot se zobrazují identifikátory záznamů."
    },
    "version": {
      "restored": "Verze byla úspěšně obnovena",
      "error": "Chyba při obnově verze"
    },
    "activated": {
      "users": "Uživatel byl úspěšně aktivován",
      "usersFromRole": "Uživatelé byli úspěšně přidáni"
    },
    "added": {
      "record": "Přehled byl úspěšně přidán",
      "rolesToUser": "Role byly úspěšně přidány",
      "rolesToUsersBulk": "Přiřazeno {{assigned}} rolí, {{users}} uživatelům. Přeskočeno {{skipped}} duplicit.",
      "rolesToUsersBulk_all": "Přiřazeno {{assigned}} rolí, {{users}} uživatelům",
      "rolesToUsersBulk_partial": "Přiřazeno {{assigned}} rolí, {{users}} uživatelům. {{skipped}} duplicit přeskočeno",
      "rolesToUsersBulk_allSkipped": "Všechny vybrané role měli uživatelé již přiřazeny.",
      "rolesToTemplatesBulk": "Přiřazeno {{assigned}} rolí, {{templates}} šablonám.",
      "user": "Uživatel byl úspěšně přidán",
      "usersToRole": "Uživatelé byli úspěšně přidáni"
    },
    "calculated": {
      "error": "Chyba při přepočítávání záznamu"
    },
    "dashboard": {
      "created": "Dashboard byl úspěšně vytvořen",
      "deleted": "Dashboard byl úspěšně smazán",
      "updated": "Dashboard byl úspěšně aktualizován",
      "createFailed": "Chyba při vytváření dashboardu",
      "deleteItemFailed": "Nelze odstranit položku: Neplatné ID"
    },
    "deactivated": {
      "users": "Uživatel byl úspěšně odebrán",
      "usersFromRole": "Uživatelé byli úspěšně odebráni"
    },
    "deleted": {
      "import": "Importy byly úspěšně odebrány",
      "rolesFromUser": "Role byly úspěšně odebrány",
      "usersFromRole": "Uživatelé byli úspěšně odebráni"
    },
    "module": {
      "created": "Modul byl úspěšně vytvořen",
      "deleted": "Moduly byly úspěšně smazány",
      "updated": "Modul byl úspěšně upraven",
      "createFailed": "Chyba při vytváření modulu",
      "noData": "Modul neobsahuje žádná data",
      "missingId": "Modulu chybí ID",
      "deleteFailed": "Chyba při mazání modulu",
      "updateFailed": "Chyba při úpravě modulu"
    },
    "assistant": {
      "created": "Asistent byl úspěšně vytvořen",
      "updated": "Asistent byl úspěšně upraven",
      "deleted": "Asistent byl úspěšně smazán",
      "createFailed": "Chyba při vytváření asistenta",
      "updateFailed": "Chyba při úpravě asistenta",
      "deleteFailed": "Chyba při mazání asistenta"
    },
    "modules": {
      "orderUpdated": "Pořadí modulů bylo úspěšně upraveno"
    },
    "saved": {
      "user": "Uživatel byl úspěšně uložen"
    },
    "updated": {
      "record": "Přehled byl úspěšně upraven",
      "widget": "Widget byl úspěšně upraven",
      "role": "Role byla úspěšně upravena",
      "rolesToUser": "Role byly úspěšně aktualizovány",
      "validFrom": "Platnost byla úspěšně upravena",
      "validUntil": "Platnost byla úspěšně upravena",
      "error": "Při ukládání došlo k chybě"
    },
    "archived": {
      "agendas": "Agenda byla úspěšně archivována"
    },
    "record": {
      "shared": "Záznam byl úspěšně sdílen",
      "error": "Chyba při sdílení záznamu"
    },
    "transfered": {
      "roles": "Role byly úspěšně přeneseny"
    },
    "action": {
      "completed": "Akce byla úspěšně dokončena",
      "loadFailed": "Akci '{{actionType}}' se nepodařilo načíst kvůli poškozeným datům"
    },
    "error": {
      "action": "Akce selhala",
      "save": "Při ukládání došlo k chybě",
      "invalidBreadcrumbStructure": "Neplatná struktura navigace"
    }
  },
  "search": {
    "_": "Hledat",
    "noResults": "Žádné výsledky",
    "failed": "Nepodařilo se načíst výsledky"
  },
  "view": {
    "added": "Pohled byl úspěšně přidán",
    "successfully": {
      "deleted": "Pohled byl úspěšně smazán"
    },
    "table": {
      "add": "Přidat pohled",
      "addColumn": "Přidat sloupec",
      "addCondition": "Přidat podmínku",
      "comparisonType": "Vyberte porovnání",
      "Contains": "Obsahuje",
      "edit": "Upravit pohled",
      "HasCountOf": "Má počet",
      "HasNotCountOf": "Nemá počet",
      "IsBigger": "Je větší",
      "IsBiggerBy": "≧ zdroj +/- hodnota",
      "IsEmpty": "Je prázdné",
      "IsEqual": "Rovná se",
      "IsNotEmpty": "Není prázdné",
      "IsNotEqual": "Nerovná se",
      "IsSmaller": "Je menší",
      "IsSmallerBy": "≦ zdroj +/- hodnota",
      "name": "Název pohledu",
      "None": "Žádný",
      "noneColumnError": "Tabulka musí mít alespoň jeden sloupec",
      "NotContains": "Neobsahuje",
      "oneEnabledColumnError": "Tabulka musí mít alespoň jeden sloupec povolený",
      "variable": "Variabilní",
      "filtering": "Filtrovací",
      "editable": "Interaktivní",
      "IsPressed": "Je stisknuto",
      "IsChecked": "Je zaškrtnuto",
      "IsUnchecked": "Je nezaškrtnuto"
    }
  },
  "substitution": {
    "titleNew": "Nový zástup",
    "titleEdit": "Upravit zástup",
    "allUsersTableTitle": "Zástupy všech uživatelů",
    "fields": {
      "substitutionType": "Typ zástupu",
      "dateFrom": "Datum od",
      "dateTo": "Datum do",
      "substituteUser": "Zastupující uživatel",
      "roles": "Role",
      "permanentSubstitution": "Trvalý zástup",
      "allowNotificationRedirect": "Odesílat zastupujícímu notifikace"
    },
    "modal": {
      "delete": {
        "title": "Smazat zástup",
        "message": "Opravdu chcete smazat tento zástup?",
        "rows": "Opravdu chcete smazat vybrané zástupy?"
      }
    },
    "errors": {
      "cannotDeleteActiveOrPastSubstitution": "Nelze smazat aktivní nebo minulý zástup"
    },
    "selectUser": "Vyberte uživatele",
    "selectAbsentUser": "Vyberte nepřítomného uživatele",
    "selectRoles": "Vyberte role",
    "searchRoles": "Hledat role nebo štítky...",
    "rolesWithoutTags": "Role bez štítků",
    "tags": "Štítky",
    "roles": "Role",
    "noSubstitutingUsersAvailable": "Pro vaše role nejsou k dispozici žádní zastupující uživatelé",
    "noRolesSelected": "Nejsou vybrány žádné role",
    "noUsersToSubstitute": "Nejsou k dispozici žádní uživatelé k zastupování",
    "selectUserToSubstitute": "Vyberte uživatele k zastupování",
    "activateSubstitution": "Aktivovat zástup",
    "type": {
      "absence": "Nepřítomnost",
      "substitution": "Zástup"
    },
    "successfullyDeleted": "Zástup byl úspěšně smazán"
  }
}
